<mat-spinner [diameter]="40" *ngIf="isLoading"></mat-spinner>
<form
  [formGroup]="form"
  (submit)="onSave()"
  class="overflow-hidden"
  *ngIf="data !== undefined && !isLoading"
>
  <div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
    <h4 class="m-0 qqmeTxt_2 text-lg font-medium" fxFlex="auto">Update profile image</h4>

    <button
      class="text-secondary ml-4"
      mat-icon-button
      type="button"
      (click)="onClose()"
    >
      <mat-icon [icIcon]="icClose"></mat-icon>
    </button>
  </div>

  <mat-divider class="-mx-6 text-border"></mat-divider>

  <mat-dialog-content fxLayout="column">


    <div
    class="upload-box"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    [ngClass]="{ 'drag-over': isDragOver }"
  >
    <p class="head m-0">Upload profile image</p>
    <p class="sub-head m-0 mt-1">
      Drop file here or
      <label class="browse-button">
        browse
        <input
          type="file"
          #filePicker
          (change)="onImagePicked($event)"
          style="display: none"
          accept=".png, .jpg, .jpeg"
          hidden
        />
      </label>
    </p>
    <p class="label m-0">Supports PNG, JPG, JPEG</p>
  </div>

    <div
      class="image-container mt-2"
      *ngIf="imagePreview"
    >
      <img [src]="imagePreview" [alt]="" class="image" />
      <button
        mat-icon-button
        color="warn"
        aria-label="Delete"
        (click)="onClearImage()"
        class="clear-button"
      >
        <mat-icon matTooltip="clear">cancel</mat-icon>
      </button>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="my-3">
   
    <button
      mat-button
      mat-dialog-close
      type="button"
      class="qqmeIcon-2"
      matTooltip="Cancel"
      matTooltipPosition="above"
    >
    Cancel
    </button>
 
    <button mat-button class="markAs-complete" type="submit" [disabled]="isUploading">
      <mat-spinner *ngIf="isUploading" diameter="20"></mat-spinner>
      <span *ngIf="!isUploading">Update profile image</span>
    </button>
  </mat-dialog-actions>
</form>
